import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=20faa832"
var script = {}
import style0 from "./Avatar.vue?vue&type=style&index=0&id=20faa832&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports